<template>
  <v-card class="pa-2 text-center" outlined tile>
   {{  Articulo[0].Stock }}
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Articulo"]),

  },
};
</script>

<style></style>
